import { memo } from 'react'
import PropTypes from 'prop-types'

const Authenticator = ({ sagaSignIn, isAuth, children, is_logout }) => {
    const currURL = window.location.href
    const codeMatch = currURL.match('[?#&]code=([^&]*)')

    if (is_logout) {
        return null
    } else if (!isAuth && currURL.includes('/logout')) {
        return null
    } else if (!isAuth) {
        if (!(codeMatch && codeMatch[1])) {
            sagaSignIn()
            return null
        }
    } else {
        return children
    }
}

Authenticator.propTypes = {
    sagaSignIn: PropTypes.func,
    isAuth: PropTypes.bool,
    children: PropTypes.node,
    is_logout: PropTypes.bool,
}

export default memo(Authenticator)
